<template>
  <thux-table
    :instance="instance"
    :instance-name="instanceName"
    :order-by-dict="orderByDict"
    :goBack="goBack"
    :list="list"
    :fieldName="fieldName"
    :fields="fields"
    :fields-column="fieldsColumn"
    :select-all="selectAll"
    :selected-list="selectedList"
    :get-local-selected-all="getLocalSelectedAll"
    :local-selected-list="localSelectedList"
    @check-all="checkAll"
    @check-none="checkNone"
    @set-selected-row="setSelectedRow"
    :show-checks="showChecks"
    :show-edit-button="showEditButton"
    @change-status="changeInstanceStatus"
    @sort-changed="orderTable"
    @remove-order-by="removeOrderFromTable"
    @open-edit-form="$emit('open-edit-form', $event)"
    @open-detail-form="$emit('open-detail-form', $event)"
  >
    <template slot="date_nomination_sec_role" slot-scope="row">
        <span>{{ row.item.date_nomination_sec_role | date}}</span>
    </template>
    <template slot="date_nomination_download" slot-scope="row">
        <a
          v-if="row.item.nomination_id"
          href="#"
          class="ml-2"
          v-has-perms="downloadDocRolePerm"
          v-b-tooltip.hover
          :title="'Download' | translate"
          @click.prevent="downloadNomination(row.item)"
        >
          <i class="fas fa-download"></i>
        </a>
    </template>
    <template slot="last_base_training" slot-scope="row">
        <span>{{ row.item.last_base_training ? row.item.last_base_training.doc : '' }}</span>
    </template>
    <template slot="last_base_training_date" slot-scope="row">
        <span :class="baseTrainingDateClass(row.item)">{{ (row.item.last_base_training ? row.item.last_base_training.date_end : '') | date }}</span>
    </template>
    <template slot="last_update_training" slot-scope="row">
        <span>{{ row.item.last_update_training ? row.item.last_update_training.doc : ''}}</span>
    </template>
    <template slot="last_update_training_date" slot-scope="row">
        <span :class="updateTrainingDateClass(row.item)">{{ (row.item.last_update_training ? row.item.last_update_training.date_end : '') | date }}</span>
    </template>
  </thux-table>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { TYPES as ORGANIZATION_CNT_SECURITY_ROLE_TYPES } from './store'
import { TYPES as UPLOAD_DOCUMENT_TYPES } from '../../document/upload-document/store'
import { hasPerm } from '@/components/PermissionHelper'

import ThuxTableMixin from '../../../components/thux-table/ThuxTableMixin'
import ThuxTableChecksMixin from '../../../components/thux-table/thux-table-checks/ThuxTableChecksMixin'

export default {
  name: 'OrganizationContactTable',
  mixins: [ThuxTableMixin, ThuxTableChecksMixin],
  data () {
    return {
      fields: [
        {
          key: 'contact__last_name',
          label: this.$t('Last name'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: true,
          value: 'contact_last_name'
        },
        {
          key: 'contact__first_name',
          label: this.$t('First name'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: true,
          value: 'contact_first_name'
        },
        {
          key: 'security_role__name',
          label: this.$t('Contact Security Role'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: true,
          value: 'security_role_name'
        },
        {
          key: 'date_nomination_sec_role',
          label: this.$t('Nomination date'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          custom: true,
          sortable: true
        },
        {
          key: 'date_nomination_download',
          label: this.$t('Nomination'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: false,
          custom: true
        },
        {
          key: 'contact__organization_contacts__work_place__name',
          label: this.$t('Work place'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: true,
          value: 'work_place_name'
        },
        {
          key: 'contact__organization_contacts__department',
          label: this.$t('Department'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: true,
          value: 'department_name'
        },
        {
          key: 'last_base_training',
          label: this.$t('Base training'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: false,
          custom: true
        },
        {
          key: 'last_base_training_date',
          label: this.$t('Base training date end'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: true,
          custom: true
        },
        {
          key: 'last_update_training',
          label: this.$t('Update training'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: false,
          custom: true
        },
        {
          key: 'last_update_training_date',
          label: this.$t('Update training date end'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: true,
          custom: true
        }
      ],
      fieldsColumn: [
        'contact__last_name', 'contact__first_name', 'security_role__name', 'date_nomination_sec_role'
      ],
      downloadDocRolePerm: 'document_uploaddocument_download_attachment'
    }
  },
  computed: {
    ...mapGetters({
      selectAll: ORGANIZATION_CNT_SECURITY_ROLE_TYPES.GENERIC.organization.organizationcontactsecurityrole.LIST.GETTERS.selectAll,
      selectedList: ORGANIZATION_CNT_SECURITY_ROLE_TYPES.GENERIC.organization.organizationcontactsecurityrole.LIST.GETTERS.selectedList
    }),
    showChecks () {
      return true
    },
    showEditButton () {
      return hasPerm('organization_organizationcontact_update')
    }
  },
  methods: {
    ...mapMutations({
      setList: ORGANIZATION_CNT_SECURITY_ROLE_TYPES.GENERIC.organization.organizationcontactsecurityrole.LIST.MUTATIONS.setList,
      setSelectedList:
        ORGANIZATION_CNT_SECURITY_ROLE_TYPES.GENERIC.organization.organizationcontactsecurityrole.LIST.MUTATIONS.setSelectedList,
      setSelectAll: ORGANIZATION_CNT_SECURITY_ROLE_TYPES.GENERIC.organization.organizationcontactsecurityrole.LIST.MUTATIONS.setSelectAll
    }),
    ...mapActions({
      ...ORGANIZATION_CNT_SECURITY_ROLE_TYPES.GENERIC.organization.organizationcontactsecurityrole.LIST.ACTIONS,
      downloadUploadDocument: UPLOAD_DOCUMENT_TYPES.GENERIC.document.uploaddocument.LIST.ACTIONS.download
    }),
    downloadNomination (item) {
      this.downloadUploadDocument({
        id: item.nomination_id,
        action: 'download-attachment',
        simpleFileName: `nomina_${item.contact_last_name || ''}_${item.contact_first_name || ''}`.trim() + '.pdf'
      })
    },
    isDatePassed (date) {
      if (date) {
        if (new Date() > new Date(date)) {
          return true
        }
      }
      return false
    },
    baseTrainingDateClass (item) {
      if (item.last_update_training) return ''
      const baseDate = item.last_base_training && item.last_base_training.date_end
      return this.dateExpiryClass(baseDate)
    },
    updateTrainingDateClass (item) {
      const updateDate = item.last_update_training && item.last_update_training.date_end
      return this.dateExpiryClass(updateDate)
    },
    dateExpiryClass (dateStr) {
      if (!dateStr) return ''
      const date = new Date(dateStr)
      const now = new Date()
      const threeMonthsAhead = new Date()
      threeMonthsAhead.setMonth(threeMonthsAhead.getMonth() + 3)
      if (date < now) return 'text-danger'
      if (date < threeMonthsAhead) return 'text-warning'
      return 'text-success'
    }
  }
}
</script>
